
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
@Component({
  name: "NVTag",
  components: {},
})
export default class NVTag extends BaseVue {
  @Prop({ default: "" }) name!: any;
  @Prop({ default: false }) checked!: any;
  @Prop({ default: 0 }) badgeCount!: any;
  @Prop({ default: "primary" }) badgeType!: any;
  mounted() {}
  clickEvent() {
    this.$emit("on-change", true, this.name);
    this.$emit("click", this.name);
    // this.$emit("dblclick", this.name);
  }
  dblclick(){
    // this.$emit("on-change", true, this.name);
    this.$emit("dblclick", this.name);
  }
}
